import { createContext, useContext } from 'react';

export type ExpandDirection = 'top' | 'right' | 'bottom' | 'left';

export interface NodeActions {
  onDelete: (nodeId: string) => void;
  onDuplicate: (nodeId: string) => void;
  onToggleLock: (nodeId: string) => void;
  onExpand: (nodeId: string, direction: ExpandDirection) => void;
  onDeleteMany: (nodeIds: string[]) => void;
  onDuplicateMany: (nodeIds: string[]) => void;
  onCopy: (nodeId: string) => void;
  onCopyMany: (nodeIds: string[]) => void;
  onBringToFront: (nodeId: string) => void;
  onSendToBack: (nodeId: string) => void;
  onBringForward: (nodeId: string) => void;
  onSendBackward: (nodeId: string) => void;
  onSelectAll: () => void;
  onUpdateStroke: (nodeId: string, strokeColor: string, strokeWidth: number) => void;
  /** Detach all children + delete the frame. Frame-only — calling on a
   *  non-frame node is a no-op at the host level (the toolbar + menu
   *  branches that surface this only render for nodeType === 'frame'). */
  onUngroup: (nodeId: string) => void;
  /** Wrap N selected nodes in a new frame (Figma "Group" semantics).
   *  bbox-positions the new frame, rebases children to frame-local,
   *  sets parentId + extent='parent', single transact = single undo.
   *  Locked nodes are skipped. Returns void at the action surface;
   *  the underlying hook returns the new frame id but surfaces don't
   *  consume it. No-op when ids.length < 2 (or all skipped/locked). */
  onGroupMany: (nodeIds: string[]) => void;
}

export const NodeActionsContext = createContext<NodeActions | null>(null);

export function useNodeActions(): NodeActions | null {
  return useContext(NodeActionsContext);
}
